export const EMPRESA_NUEVA_MUTUAL = 103;
export const EMPRESA_BSA = 20;
export const GRUPO_GP = 1;

export const initialStateVehiculo = {
   infoauto: null,
   marca: '',
   marcaDescripcion: '',
   anio: null,
   modelo: '',
   modeloDescripcion: '',
   patente: '',
   tipoUso: '',
   ceroKm: false,
   esCamion: false,
   tieneGnc: false,
   tieneRastreo: false,
   tieneGarage: false,
   motor: '',
   chasis: '',
   gnc: {},
   rastreo: {
      tipoRastreador: '',
   },
   accesorios: [],
};

/** Garage SI para NM y terceros (no grupo 1, no BSA). */
export function getInitialStateVehiculo(idEmpresa = null, idGrupo = null) {
   const empresa = Number(idEmpresa);
   const grupo = Number(idGrupo);
   const tieneGarage =
      idEmpresa != null &&
      empresa !== EMPRESA_BSA &&
      grupo !== GRUPO_GP;

   return {
      ...initialStateVehiculo,
      tieneGarage,
   };
}

export const initialStateCotizacion = {
   idCotizacion: null,
   idCompania: null,
   nombreCompania: '',
   producto: '',
   texto: '',
   descripcion: null,
   premio: 0,
   franquicia: null,
   codigoProducto: '',
   logo: '',
   seleccionada: false,
   coberturas: [],
};

export const initialStateAcreedorPrendario = {
   razonSocial: '',
   cuit: '',
   codigoPostal: '',
};

export const initialStatePago = {
   canalFormaPago: null,
   cbuOrTarjeta: null,
};

export const initialStateFinanciamiento = {
   // true => prenda/leasing, false => crédito tradicional
   esPrendaLeasing: true,
   esPrendaLeasingEditable: false,
};

export function getInitialStateAutomotor(idEmpresa = null, idGrupo = null) {
   return {
      formulario: {
         vehiculo: getInitialStateVehiculo(idEmpresa, idGrupo),
         acreedorPrendario: {
            ...initialStateAcreedorPrendario,
         },
         pago: {
            ...initialStatePago,
         },
         financiamiento: {
            ...initialStateFinanciamiento,
         },
      },

      cotizaciones: [{}],
      mostrarComparacion: false,
      loadingCotizaciones: true,
      opcionesOrden: [
         { label: 'Precio (menor a mayor)', value: 'precio_asc' },
         { label: 'Precio (mayor a menor)', value: 'precio_desc' },
         { label: 'Compañía (A-Z)', value: 'compania_asc' },
         { label: 'Compañía (Z-A)', value: 'compania_desc' },
         { label: 'Más popular', value: 'popular' },
      ],
      filtrosCotizacion: {
         busqueda: '',
         rangoPrecio: [20000, 80000],
         ordenar: null,
      },
      marcaOptions: [{ label: 'Seleccione marca', value: '' }],
      modeloOptions: [{ label: 'Seleccione modelo', value: '' }],
      tipoUsoOptions: [
         { label: 'Seleccione tipo de uso', value: '' },
         { label: 'Particular', value: 'particular' },
         { label: 'Comercial', value: 'comercial' },
      ],
      tipoIvaOptions: [
         { label: 'Seleccione tipo IVA', value: '' },
         { label: 'Responsable Inscripto', value: 'ri' },
         { label: 'Responsable No Inscripto', value: 'rni' },
         { label: 'Exento', value: 'exento' },
         { label: 'Monotributista', value: 'monotributista' },
         { label: 'Consumidor Final', value: 'consumidor_final' },
      ],
      rastreadorOptions: [],
      accesoriosOptions: [],
      actividadOptions: [],
      ingresosBrutosOptions: [],
      entidadFinancieraOptions: [],
      canalPagoOptions: [],
      fotosRequeridasElNorte: [],
      tabsCotizaciones: [
         {
            id: 1,
            title: '',
            icon: '',
            planType: '',
         },
      ],
      tipoPersonaOptions: [
         { label: 'Seleccione tipo de persona', value: '' },
         { label: 'Física', value: 1 },
         { label: 'Jurídica', value: 2 },
      ],
      estadoPoliza: null,
      companiasHabilitadas: [],
      companiasNoDisponibles: [],
      tipoCuentaOptions: [
         { label: 'Cuenta Corriente', value: 'cuenta_corriente' },
         { label: 'Caja de Ahorro', value: 'caja_ahorro' },
      ],
   };
}

export default getInitialStateAutomotor();
